import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    PLANT_GROWTH_TEMPLATES_QUERY,
    GROWTH_TEMPLATES_OF_A_PLANT_QUERY,
    SINGLE_PLANT_GROWTH_TEMPLATE_QUERY,
    CREATE_PLANT_GROWTH_TEMPLATE_MUTATION,
    UPDATE_PLANT_GROWTH_TEMPLATE_MUTATION,
    DELETE_PLANT_GROWTH_TEMPLATE_MUTATION
} from "@/graphql/plantGrowthTemplates.js";

const state = {
    plantGrowthTemplates: []
};

const getters = {};

const mutations = {
    [types.SET_PLANT_GROWTH_TEMPLATES](state, plantGrowthTemplates) {
        state.plantGrowthTemplates = plantGrowthTemplates;
    },
    [types.SORT_PLANT_GROWTH_TEMPLATES](state) {
        state.plantGrowthTemplates.sort(function(a, b) {
            return a.node.name.toLowerCase() == b.node.name.toLowerCase()
                ? 0
                : a.node.name.toLowerCase() > b.node.name.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_PLANT_GROWTH_TEMPLATE](state, plantGrowthTemplate) {
        var index = state.plantGrowthTemplates.findIndex(function(element) {
            return element.node.id == plantGrowthTemplate.id;
        });

        const node = { node: plantGrowthTemplate };

        if (index > -1) {
            state.plantGrowthTemplates.splice(index, 1, node);
        } else {
            state.plantGrowthTemplates.unshift(node);
        }
    },
    [types.DELETE_PLANT_GROWTH_TEMPLATE](state, plantGrowthTemplate) {
        var index = state.plantGrowthTemplates.find(function(element, index) {
            if (element.id == plantGrowthTemplate.id) {
                return index;
            }
        });

        if (index > -1) {
            state.plantGrowthTemplates.splice(index, 1);
        }
    }
};

const actions = {
    async fetchPlantGrowthTemplates(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PLANT_GROWTH_TEMPLATES_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    const plantGrowthTemplates = response.data.tenantPlantGrowthTemplates.edges;

                    // update store
                    context.commit(types.SET_PLANT_GROWTH_TEMPLATES, plantGrowthTemplates);

                    // sort
                    context.commit(types.SORT_PLANT_GROWTH_TEMPLATES)

                    resolve(plantGrowthTemplates);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchGrowthTemplatesOfAPlant(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: GROWTH_TEMPLATES_OF_A_PLANT_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        plant_Id: payload
                    }
                })
                .then(response => {
                    const tenantPlantGrowthTemplates = JSON.parse(JSON.stringify(response.data.tenantPlantGrowthTemplates.edges));

                    resolve(tenantPlantGrowthTemplates);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSinglePlantGrowthTemplate(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_PLANT_GROWTH_TEMPLATE_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plantGrowthTemplate = response.data.plantGrowthTemplate;

                    // update store
                    context.commit(types.UPSERT_PLANT_GROWTH_TEMPLATE, plantGrowthTemplate);

                    // sort
                    context.commit(types.SORT_PLANT_GROWTH_TEMPLATES)

                    resolve(plantGrowthTemplate);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createPlantGrowthTemplate(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_PLANT_GROWTH_TEMPLATE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plantGrowthTemplate =
                        response.data.createPlantGrowthTemplate.plantGrowthTemplate;

                    // update store
                    context.commit(types.UPSERT_PLANT_GROWTH_TEMPLATE, plantGrowthTemplate);

                    // sort
                    context.commit(types.SORT_PLANT_GROWTH_TEMPLATES)

                    resolve(plantGrowthTemplate);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updatePlantGrowthTemplate(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_PLANT_GROWTH_TEMPLATE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plantGrowthTemplate =
                        response.data.updatePlantGrowthTemplate.plantGrowthTemplate;

                    // update store
                    context.commit(types.UPSERT_PLANT_GROWTH_TEMPLATE, plantGrowthTemplate);

                    // sort
                    context.commit(types.SORT_PLANT_GROWTH_TEMPLATES)

                    resolve(plantGrowthTemplate);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deletePlantGrowthTemplate(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_PLANT_GROWTH_TEMPLATE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plantGrowthTemplate =
                        response.data.deletePlantGrowthTemplate.plantGrowthTemplate;

                    // update store
                    context.commit(types.DELETE_PLANT_GROWTH_TEMPLATE, plantGrowthTemplate);

                    resolve(plantGrowthTemplate);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
